<script setup lang="ts">
defineProps<{
  label: string
  hint?: string
  error?: string
  required?: boolean
}>()
</script>

<template>
  <label class="block">
    <span class="mb-1.5 flex items-baseline gap-1.5">
      <span class="col-head">{{ label }}</span>
      <span v-if="required" class="text-accent text-[11px]">*</span>
      <span v-if="hint" class="text-dim text-[11px] font-normal">{{ hint }}</span>
    </span>
    <slot />
    <span v-if="error" class="mt-1 block text-[12px] text-danger">{{ error }}</span>
  </label>
</template>
